<template>
<div class="patientManagement">
  <div class="leftBar">
    <div class="searchBox">
      <div class="search" style="width: 100%;">
        <el-input
            v-model="search.key"
            @input="handleSearch"
            placeholder="姓名/手机尾号/档案号/身份证号">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>
    <div class="listTabBox">
      <div class="tabBox">
        <div class="tabItem">
          共<span>{{ total }}</span>
        </div>
      </div>
    </div>
    <div class="listBox" @scroll="handleScroll" ref="listBox">

      <div :class="active === index ?'itemBoxActive':'itemBox'"  
           v-for="(item, index) in patientList" 
           :key="item.caseNumber + '_' + index"
           @click="selectPatient(item, index)">
        <div class="userInfo">
          <div class="userImg">
            <i class="el-icon-user-solid"></i>
          </div>
          <div class="userName">{{ item.name || '未知' }}</div>
        </div>
        <div class="ageBox">
          <span class="age">{{ calculateAge(item.birthday) }}</span>
<!--          <span class="caseNumber">{{ item.caseNumber || '' }}</span>-->
        </div>
        <div class="createTime">{{ formatDate(item.visitDate) }}</div>
      </div>
      <div class="loading" v-if="loading">加载中...</div>
      <div class="load-more-btn" v-if="shouldShowLoadMoreBtn" @click="loadMore">
        加载更多
      </div>
      <div class="no-more" v-if="noMore && patientList.length > 0">没有更多数据了</div>
      <div class="nothing" v-if="!loading && patientList.length === 0">暂无患者数据</div>
    </div>
  </div>
  <div class="contentBox">
    <el-tabs v-model="contentActive" @tab-click="contentHandleActive">
      <el-tab-pane label="档案详情" name="1">
        <patientProfileDetails 
                  :patient-detail="patientDetail" 
                  :loading="detailLoading"
                  @patient-updated="handlePatientUpdated">
                </patientProfileDetails>
      </el-tab-pane>
      <el-tab-pane label="病历记录" name="2">
        <patientMedicalRecord :selectedPatient="selectedPatient"></patientMedicalRecord>
      </el-tab-pane>
    </el-tabs>
  </div>
</div>
</template>
<script>
import { post, get } from "@/api/api.js";
import patientProfileDetails from "@/views/patientManagement-operation/patientProfileDetails.vue";
import patientMedicalRecord from "@/views/patientManagement-operation/patientMedicalRecord.vue";

export default {
  name: "patientManagement",
  components: {
    patientProfileDetails,
    patientMedicalRecord
  },
  data() {
    return {
      total: 0,
      search: {
        key: '',
      },
      loading: false,
      noMore: false,
      pageNum: 1,
      pageSize: 20, // 调整页面大小，提高加载性能
      userInfo: JSON.parse(localStorage.getItem('User')),
      patientList:[], //患者列表
      active: -1, // 初始状态没有选中任何项
      contentActive: '1',
      searchTimer: null, // 搜索防抖定时器
      selectedPatient: null, // 当前选中的患者
      patientDetail: null, // 患者详情数据
      detailLoading: false // 详情加载状态

    }
  },

  computed: {
    // 判断是否需要显示加载更多按钮
    shouldShowLoadMoreBtn() {
      // 如果正在加载、没有更多数据、或者没有数据，则不显示
      if (this.loading || this.noMore || this.patientList.length === 0) {
        return false;
      }

      // 如果数据量较少（小于页面大小），很可能没有滚动条，显示按钮
      if (this.patientList.length < this.pageSize) {
        return true;
      }

      // 检查是否有滚动条
      this.$nextTick(() => {
        const listBox = this.$refs.listBox;
        if (listBox) {
          const hasScrollbar = listBox.scrollHeight > listBox.clientHeight;
          return !hasScrollbar; // 没有滚动条时显示按钮
        }
      });

      return true; // 默认显示
    }
  },
  mounted() {
    this.queryPatientManagementList(false, null, true); // 初始化加载患者列表
  },

  watch: {
    // 监听搜索关键词变化，实现防抖查询
    'search.key'(newVal, oldVal) {
      // 清除之前的定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      // 设置新的定时器，500ms后执行查询
      this.searchTimer = setTimeout(() => {
        this.handleSearch();
      }, 500);
    }
  },

  beforeDestroy() {
    // 清理定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },

  methods: {
    handleSearch () {
      // 重置分页并重新查询
      this.pageNum = 1;
      this.noMore = false;
      this.active = -1; // 重置选中状态
      this.selectedPatient = null; // 清空选中的患者
      this.patientDetail = null; // 清空患者详情
      this.queryPatientManagementList(false, null, true); // 搜索后自动选中第一条
    },

    // 处理滚动事件，实现滚动到底部加载更多
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 当滚动到距离底部50px时，触发加载更多
      if (scrollHeight - scrollTop - clientHeight < 50 && !this.loading && !this.noMore) {
        this.queryPatientManagementList(true);
      }
    },

    // 选择患者
    async selectPatient(patient, index) {
      this.active = index;
      this.selectedPatient = patient;
      console.log('选中患者:', patient);

      // 调用患者详情API
      await this.getPatientDetail(patient.caseNumber);
    },

    // 获取患者详情
    async getPatientDetail(caseNumber) {
      if (!caseNumber) {
        this.$message.error('病历号不能为空');
        return;
      }

      this.detailLoading = true;
      try {
        const response = await get(`/operation/patient/management/getDetail/${caseNumber}`);
        console.log('患者详情API响应:', response);

        if (response.data && response.data.code === 200) {
          this.patientDetail = response.data.data;

          // 确保地址字段存在，如果API返回的字段名不同，进行映射
          if (this.patientDetail) {
            // 如果没有代码字段但有名称字段，可能需要通过名称查找代码
            // 这里先确保字段存在，避免undefined
            this.patientDetail.provinceCode = this.patientDetail.provinceCode || '';
            this.patientDetail.cityCode = this.patientDetail.cityCode || '';
            this.patientDetail.districtCode = this.patientDetail.districtCode || '';
          }

          console.log('患者详情数据:', this.patientDetail);
        } else {
          this.$message.error(response.data?.message || '获取患者详情失败');
        }
      } catch (error) {
        console.error('获取患者详情失败:', error);
        this.$message.error('获取患者详情失败，请稍后重试');
      } finally {
        this.detailLoading = false;
      }
    },

    // 计算年龄
    calculateAge(birthday) {
      if (!birthday) return '未知';

      try {
        const birthDate = new Date(birthday);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }

        return age >= 0 ? `${age}岁` : '未知';
      } catch (error) {
        console.warn('计算年龄失败:', error);
        return '未知';
      }
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';

      try {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      } catch (error) {
        console.warn('格式化日期失败:', error);
        return '';
      }
    },
    //分页查询患者列表
    queryPatientManagementList (isLoadMore = false, patient, autoSelect = true, noreset) {
      // 如果正在加载或者是加载更多但已经没有更多数据，则直接返回
      if (this.loading || (isLoadMore && this.noMore)) {
        return;
      }

      // 如果是加载更多，先增加页码
      if (isLoadMore) {
        this.pageNum++;
      }

      this.loading = true;
      post('/operation/patient/management/page', {
        name: this.search.key || undefined,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        console.log('患者管理API响应:', res);

        if (res && res.data && res.data.code === 200) {
          const data = res.data.data;
          const list = data.list || [];
          this.total = data.total
          console.log('获取到的患者列表:', list);

          if (isLoadMore) {
            this.patientList = [...this.patientList, ...list];
          } else {
            this.patientList = list;
          }

          // 判断是否还有更多数据
          this.noMore = list.length < this.pageSize;

          // 如果没有数据且是加载更多，回退页码
          if (list.length === 0 && isLoadMore) {
            this.pageNum--;
          }

          console.log('患者列表更新完成，总数:', this.patientList.length);

          // 检查滚动条状态
          this.checkScrollbar();

          // 如果是初始化加载且需要自动选中，选中第一条数据
          if (!isLoadMore && autoSelect) {
            if (this.patientList.length > 0) {
              this.$nextTick(() => {
                this.selectPatient(this.patientList[0], 0);
              });
            } else {
              // 没有数据时清空选中状态
              this.active = -1;
              this.selectedPatient = null;
              this.patientDetail = null;
            }
          }
        } else {
          console.error('患者管理API响应异常:', res);
          this.$message.error(res?.data?.msg || '获取患者列表失败');

          // 如果是加载更多失败，回退页码
          if (isLoadMore) {
            this.pageNum--;
          }
        }
      }).catch(error => {
        console.error('查询患者列表失败:', error);
        this.$message.error('网络错误，请重试');

        // 如果是加载更多失败，回退页码
        if (isLoadMore) {
          this.pageNum--;
        }
      }).finally(() => {
        this.loading = false;
      })
    },

    // 手动加载更多
    loadMore() {
      if (!this.loading && !this.noMore) {
        this.queryPatientManagementList(true);
      }
    },

    // 检查是否有滚动条
    checkScrollbar() {
      this.$nextTick(() => {
        const listBox = this.$refs.listBox;
        if (listBox) {
          const hasScrollbar = listBox.scrollHeight > listBox.clientHeight;
          // 如果没有滚动条且还有更多数据，可以考虑自动加载一页
          if (!hasScrollbar && !this.noMore && this.patientList.length > 0 && this.patientList.length < this.pageSize * 2) {
            // 可以在这里添加自动加载逻辑，但为了用户体验，我们保持手动控制
            console.log('列表较短，建议用户点击加载更多');
          }
        }
      });
    },

    contentHandleActive (tab, event) {
      console.log(tab, event);
    },

    // 处理患者信息更新事件
    async handlePatientUpdated(updatedData) {
      try {
        console.log('患者信息已更新:', updatedData);

        // 重新请求患者列表
        this.pageNum = 1; // 重置页码
        await this.queryPatientManagementList(false);

        // 如果当前有选中的患者，重新请求患者详情
        if (this.selectedPatient && this.selectedPatient.caseNumber) {
          await this.getPatientDetail(this.selectedPatient.caseNumber);
        }

        // this.$message.success('患者信息更新成功');
      } catch (error) {
        console.error('刷新数据失败:', error);
        this.$message.error('刷新数据失败，请手动刷新页面');
      }
    },
  }
}
</script>

<style lang="less" scoped>
.patientManagement {
  height: calc(100vh - 120px);
  background-color: rgb(245,245,245);
  font-size: 14px;
  display: flex;
  align-items: center;
  .leftBar{
    min-width: 285px;
    height: 100%;
    border-right:1px solid #eaedf1;
    overflow: hidden;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background-color: #fff;
    max-width: 305px;
    .searchBox{
      display: flex;
      align-items: center;
      gap: 10px;
      height: 55px;
      border-bottom:1px solid #eaedf1;
      justify-content: space-around;
      padding: 0 10px;
      .search{
        /deep/ .el-input__inner{
          height: 32px;
          line-height: 32px;
        }
        /deep/ .el-input__icon{
          line-height: 32px;
        }
      }
      .deliveringBtn:hover{
        background-color: #23cf67;
      }
      .deliveringBtn:active{
        background-color: #08a446;
      }
      .deliveringBtn{
        height: 32px;
        width: 71.6px;
        background-color: #1ec761;
        border-radius: 6px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        user-select: none;
        span{
          font-size: 25px;
          letter-spacing: 3px;
          font-weight: 200;
          padding-top: 2px;
        }

      }
      .deliveringBtnNot{
        height: 32px;
        width: 71.6px;
        background-color: rgba(253, 253, 253, 0.91);
        border-radius: 6px;
        color: rgba(225, 225, 225, 0.91);
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid;
        user-select: none;
        span{
          font-size: 25px;
          letter-spacing: 3px;
          font-weight: 200;
          padding-top: 2px;
        }
      }
    }
    .listTabBox{
      height: 41px;
      width: 100%;
      border-bottom:1px solid #eaedf1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .tabBox{
        margin-left: 10px;
        .tabItem{
          color: #abb3c0;
          font-weight: 500;
          font-size: 13px;
          span{
            font-size: 13px;
            //color: red;
            margin-left: 5px;
          }
        }
      }
      .select{
        margin-right: 10px;
        width: 70px;
        height: 35px;
        //border: 1px solid red;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .dateLabel{
          position: absolute;
          color: #7a8794;
          user-select: none;
          i{
            margin-left: 5px;
          }
        }
        .pickerBox{
          opacity: 0;
          /deep/  .el-date-editor.el-input, .el-date-editor.el-input__inner{
            width: 70px;
            cursor: pointer;
          }
          /deep/ .el-input--prefix .el-input__inner{
            cursor: pointer;
          }
        }
      }
    }
    .listBox{
      //flex: 1;
      //border: 1px solid red;
      padding: 10px 10px;
      display: flex;
      flex-direction: column;
      gap: 5px;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      padding-bottom: 40px;
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
      /* 自定义滚动条样式 */
      &::-webkit-scrollbar {
        width: 7px;
        background-color: transparent;
      }

      //&:hover::-webkit-scrollbar {
      //  width: 8px;
      //  background-color: rgb(230, 234, 237);
      //}

      &:hover::-webkit-scrollbar-thumb {
        background-color: rgb(230, 234, 237);
        border-radius: 3px;
      }

      .itemBox{
        height: 44px;
        //width: 100%;
        border-radius: 8px;
        background-color: var(--primary-color2);
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
        color: var(--sideMenun-text-color);
        cursor: pointer;
        user-select: none;
        font-size: 12px;
        border: 1px solid var(--primary-color);
        transition: all 0.3s ease;
        padding-right: 8px;
        .userInfo{
          display: flex;
          align-items: center;
          gap: 5px;
          margin-left: 10px;
          .userImg{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 30px;
            width: 30px;
            border-radius: 6px;
            background-color: #fff;
            border: 1px solid #eff3f6;
            i{
              font-size: 18px;
              color: #5199f8;
            }
          }
          .userName{
            width: 70px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .ageBox{
          color: #000;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          width: 100px;
          .age {}
          .caseNumber{
            font-size: 10px;
            color: #666;
          }
        }
        .createTime{
          font-size: 11px;
          font-weight: 700;
          color: rgba(0,0,0,.4);
          width: 70px;
          text-align: right;
        }
      }
      .itemBoxActive{
        height: 44px;
        //width: 100%;
        border-radius: 8px;
        background: var(--primary-color);
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
        color: #fff;
        cursor: pointer;
        user-select: none;
        font-size: 12px;
        box-shadow: 0 1px 5px var(--primary-color);
        padding-right: 8px;
        .userInfo{
          display: flex;
          align-items: center;
          gap: 5px;
          margin-left: 10px;
          .userImg{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 30px;
            width: 30px;
            border-radius: 6px;
            background-color: #fff;
            border: 1px solid #eff3f6;
            i{
              font-size: 18px;
              color: #5199f8;
            }
          }
          .userName{
            width: 70px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .ageBox{
          color: #fff;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          width: 100px;
          .age {}
          .caseNumber{
            font-size: 10px;
            color: #fff;
            opacity: 0.8;
          }
        }
        .createTime{
          font-weight: 700;
          color: #fff !important;
          width: 70px;
          text-align: right;
        }
      }
      .nothing, .loading, .no-more {
        color: #aab4bf;
        font-size: 11px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        width: 100%;
      }
      
      .load-more-btn {
        color: #1ec761;
        font-size: 12px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        width: 100%;
        cursor: pointer;
        user-select: none;
        border: 1px dashed #1ec761;
        border-radius: 6px;
        margin: 5px 0;
        transition: all 0.3s ease;
        background-color: rgba(30, 199, 97, 0.05);
        opacity: 0;
        &:hover {
          background-color: rgba(30, 199, 97, 0.1);
          color: #16a085;
          border-color: #16a085;
        }
        
        &:active {
          background-color: rgba(30, 199, 97, 0.15);
          transform: translateY(1px);
        }
      }
    }
  }
  .contentBox{
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    //border: 1px solid red;
    box-sizing: border-box;
    //background-color: #fff;
    /deep/ .el-tabs__header {
      background-color: #fff;
      padding-left: 20px;
    }
  }
}
</style>